import { UseTypedQueryOptions } from "api/UseTypedQueryOptions";
import { UseQueryResult, useQuery } from "react-query";

import { LifecycleReadDTO } from "../__generated__/CatalogueAPI";
import { CatalogueApiVersion, getLifeCycleById, getLifeCycles, getLifeCyclesAll } from "../catalogApi";

type LifecycleAllReadDTO = Record<string, LifecycleReadDTO[]>;

export function useLifeCycle(id: LifecycleReadDTO["id"]): UseQueryResult<LifecycleReadDTO | undefined> {
  return useQuery("lifecycle" + id, () => getLifeCycleById(id));
}

export default function useLifeCycles(
  props?: UseTypedQueryOptions<LifecycleReadDTO[]>,
  apiVersion?: CatalogueApiVersion
): UseQueryResult<LifecycleReadDTO[]> {
  return useQuery(["lifecycles", apiVersion], () => getLifeCycles(apiVersion), props);
}

export function useLifeCyclesAll(
  props?: UseTypedQueryOptions<LifecycleAllReadDTO>,
  apiVersion?: CatalogueApiVersion
): UseQueryResult<LifecycleAllReadDTO> {
  return useQuery(["lifecycles-all", apiVersion], () => getLifeCyclesAll(apiVersion), props);
}
